export default {
  login() {
    const token = 'token';

    return {
      data: {
        token,
      },
    };
  },
};
